import { useMemo } from 'react';

import {
  useCurrentProductId,
  useCurrentProject,
  useCurrentToolId,
} from '@adsk/alloy-provider';

export const useCurrentToolDisplayName = (): string | undefined => {
  const currentToolId = useCurrentToolId();
  const currentProject = useCurrentProject();
  const currentProductId = useCurrentProductId();

  const currentToolFromEntitlements = useMemo(
    () =>
      currentProject?.products
        ?.find((product) => product.key === currentProductId)
        ?.tools?.find((tool) => tool.key === currentToolId),
    [currentToolId, currentProject, currentProductId],
  );

  return currentToolFromEntitlements?.name;
};
